// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3yRi-","balanceDisclaimer":"posDashboard_balanceDisclaimer__3vtbj"};